module.exports = __webpack_public_path__ + "static/media/fr_add_to_apple_wallet.edcb0274.svg";